<navbar-view (actionClicked)="dialog.closeAll()"></navbar-view>
<br><br>

<h1 translate="search-page.add-a-location"></h1>

<div class="location-input" customMapAutocomplete emitOnly (locationChanged)="locationChanged($event)">
  <mat-icon>search</mat-icon>
  <input type="text" name="location" autocomplete="off" [placeholder]="'search-page.where-would-you-like-to-explore' | translate" [(ngModel)]="formField">
</div>
